import { subDays } from 'date-fns';

import { SearchParams, SearchType } from '../../core';
import { GridDays } from '../model/grid-days.model';
import { GridType } from '../model/grid-type.model';
import { TeamAlt } from '../model/team-alt.model';

export function createSearchParams(opts: {
    type: GridType;
    days: GridDays;
    userId: number;
    teamAlt: TeamAlt | null;
}): SearchParams {
    let searchType = SearchType.INDIVIDUAL;
    switch (opts.type) {
        case GridType.FOR_ME:
            searchType = SearchType.INDIVIDUAL;
            break;
        case GridType.BY_ME:
            searchType = SearchType.CREATED_BY_INDIVIDUAL;
            break;
        case GridType.FOR_MY_TEAM:
            if (opts.teamAlt === TeamAlt.TEAM_AND_SUBORDINATES) {
                searchType = SearchType.TEAM_AND_SUBORDINATES;
            } else {
                searchType = SearchType.TEAM;
            }
            break;
    }
    return {
        userId: opts.userId,
        targetUserId: opts.userId,
        searchType,
        dateRangeStart: subDays(new Date(), opts.days),
        dateRangeEnd: new Date(),
        timeZoneOffset: new Date().getTimezoneOffset(),
    };
}
